import React from 'react';
import { KanbanLaneStyled } from './kanban-lane.component.style';
export const KanbanLane = (props) => {
    return React.createElement(KanbanLaneStyled, { rowNumber: props.rowNumber }, props.children);
};
